/* eslint-disable no-nested-ternary */
import styled, { css } from 'styled-components'

import theme, { rem } from '../../utils/theme'

const DatePickerWrapper = styled.div`
  .SingleDatePickerInput {
    display: flex;
    align-items: center;
    width: 100%;
    background-color: ${`var(--gameday-inputField-inputBGColor, ${theme.inputField.inputBGColor})`};
    color: var(--gameday-body-textColorAlt, ${theme.body.textColorAlt});
  }
  .SingleDatePickerInput__withBorder {
    border-radius: 4px;
    border: 1px solid ${`var(--gameday-inputField-inputBorder, ${theme.inputField.inputBorder})`};
    height: 36px;
    max-height: 36px;
  }
  .DateRangePickerInput__withBorder {
    border-radius: 4px;
    border: 1px solid ${`var(--gameday-inputField-inputBorder, ${theme.inputField.inputBorder})`};
  }
  &.errorText .SingleDatePickerInput__withBorder,
  &.errorText .DateRangePickerInput__withBorder {
    border-color: ${props => props.theme.status.errorColor};
    svg {
      background-color: transparent !important;
    }
  }
  .SingleDatePickerInput__rtl {
    direction: rtl;
  }
  .SingleDatePickerInput__disabled {
    background-color: ${`var(--gameday-inputField-inputBGDisabled, ${theme.inputField.inputBGDisabled})`};
    opacity: ${props => props.theme.inputField.inputDisabledOpacity};
  }
  .SingleDatePickerInput__block {
    display: block;
  }
  .SingleDatePickerInput__showClearDate {
    padding-right: 30px;
  }
  .SingleDatePickerInput_clearDate {
    background: 0 0;
    border: 0;
    color: inherit;
    font: inherit;
    line-height: normal;
    overflow: visible;
    cursor: pointer;
    padding: 10px;
    margin: 0 10px 0 5px;
    position: absolute;
    right: 0;
    top: 50%;
    transform: translateY(-50%);
  }
  .SingleDatePickerInput_clearDate__default:focus,
  .SingleDatePickerInput_clearDate__default:hover {
    background: ${`var(--gameday-inputField-inputBorder, ${theme.inputField.inputBorder})`};
    border-radius: 50%;
  }
  .SingleDatePickerInput_clearDate__small {
    padding: 6px;
  }
  .SingleDatePickerInput_clearDate__hide {
    visibility: hidden;
  }
  .SingleDatePickerInput_clearDate_svg {
    fill: #82888a;
    height: 12px;
    width: 15px;
    vertical-align: middle;
  }
  .SingleDatePickerInput_clearDate_svg__small {
    height: 9px;
  }
  .SingleDatePickerInput_calendarIcon {
    ${props =>
      props.showAge &&
      css`
        width: 100%;
        margin-left: 0;
      `}
    background: 0 0;
    border: 0;
    color: inherit;
    font: inherit;
    line-height: normal;
    overflow: visible;
    cursor: pointer;
    vertical-align: middle;
    display: flex;
    padding: 0;
  }
  .SingleDatePickerInput_calendarIcon:focus {
    outline: none;
  }
  .SingleDatePickerInput_calendarIcon_svg {
    fill: #82888a;
    height: 15px;
    width: 14px;
    vertical-align: middle;
  }
  .SingleDatePickerInput__withBorder:focus-within,
  .DateRangePickerInput__withBorder:focus-within {
    border-color: ${props => props.theme.palette.primary.main};
  }
  .DateInput {
    position: relative;
    display: inline-flex;
    vertical-align: middle;
    width: ${props =>
      props.showAge ? `${rem(120)} !important` : props.customWidth ? `${props.customWidth}px !important` : 'auto'};
    color: rgb(72, 72, 72);
    border-radius: 0px;
    outline: 0px;
    border-image: initial;
    background: transparent;
  }
  .DateInput input {
    padding: 6px;
  }
  .DateRangePickerInput .DateInput {
    width: 110px;
  }
  .DateInput__small {
    width: 104px;
  }
  .DateInput__block {
    width: 100%;
  }
  .DateInput__disabled {
    background: ${`var(--gameday-inputField-inputBGDisabled, ${theme.inputField.inputBGDisabled})`};
    color: ${`var(--gameday-inputField-inputBorder, ${theme.inputField.inputBorder})`};
  }
  .DateInput_input {
    font-family: ${props => props.theme.typography.defaultFont} !important;
    font-size: ${props => props.theme.typography.fontSizeSm};
    line-height: normal;
    color: ${`var(--gameday-inputField-inputTextColor, ${theme.inputField.inputTextColor})`};
    background-color: transparent;
    border: 0;
    border-top: 0;
    border-right: 0;
    border-left: 0;
    border-radius: 0;
    width: 100%;
    text-align: left;
    letter-spacing: normal !important;
    font-weight: 400;
  }
  .DateInput_input:hover {
    cursor: pointer;
  }
  .DateInput_input__small {
    font-size: ${props => props.theme.typography.fontSizeSm};
    line-height: 16px;
    letter-spacing: 0.2px;
  }
  .DateInput_input__regular {
    font-weight: auto;
  }
  .DateInput_input__readOnly {
    user-select: none;
  }
  .DateInput_input__focused {
    outline: 0;
    background: transparent;
    border: 0;
    border-top: 0;
    border-right: 0;
    border-left: 0;
  }
  .DateInput_input__disabled {
    background: ${`var(--gameday-inputField-inputBGDisabled, ${theme.inputField.inputBGDisabled})`};
    font-style: italic;
  }
  .DateInput_screenReaderMessage {
    border: 0;
    clip: rect(0, 0, 0, 0);
    height: 1px;
    margin: -1px;
    overflow: hidden;
    padding: 0;
    position: absolute;
    width: 1px;
  }
  .DateInput_fang {
    display: none;
  }
  .DateRangePickerInput {
    background-color: ${`var(--gameday-inputField-inputBGColor, ${theme.inputField.inputBGColor})`};
    display: inline-flex;
    height: 36px;
    max-height: 36px;
  }
  .DateRangePickerInput__disabled {
    background: ${`var(--gameday-inputField-inputBGDisabled, ${theme.inputField.inputBGDisabled})`};
    opacity: ${props => props.theme.inputField.inputDisabledOpacity};
  }
  .DateRangePickerInput__rtl {
    direction: rtl;
  }
  .DateRangePickerInput__block {
    display: block;
  }
  .DateRangePickerInput__showClearDates {
    padding-right: 30px;
  }
  .DateRangePickerInput_arrow {
    display: inline-flex;
    align-items: center;
    vertical-align: middle;
    color: var(--gameday-body-textColorAlt, ${theme.body.textColorAlt});
  }
  .DateRangePickerInput_arrow_svg {
    vertical-align: middle;
    fill: var(--gameday-body-textColorAlt, ${theme.body.textColorAlt});
    height: 20px;
    width: 20px;
  }
  .DateRangePickerInput_clearDates {
    background: 0 0;
    border: 0;
    color: inherit;
    font: inherit;
    line-height: normal;
    overflow: visible;
    cursor: pointer;
    padding: 10px;
    margin: 0 10px 0 5px;
    position: absolute;
    right: 0;
    top: 50%;
    transform: translateY(-50%);
  }
  .DateRangePickerInput_clearDates__small {
    padding: 6px;
  }
  .DateRangePickerInput_clearDates_default:focus,
  .DateRangePickerInput_clearDates_default:hover {
    background: ${`var(--gameday-inputField-inputBorder, ${theme.inputField.inputBorder})`};
    border-radius: 50%;
  }
  .DateRangePickerInput_clearDates__hide {
    visibility: hidden;
  }
  .DateRangePickerInput_clearDates_svg {
    fill: #82888a;
    height: 12px;
    width: 15px;
    vertical-align: middle;
  }
  .DateRangePickerInput_clearDates_svg__small {
    height: 9px;
  }
  .DateRangePickerInput_calendarIcon {
    background: 0 0;
    border: 0;
    color: inherit;
    font: inherit;
    line-height: normal;
    overflow: visible;
    cursor: pointer;
    display: inline-block;
    vertical-align: middle;
    padding: 10px;
    margin: 0 5px 0 10px;
  }
  .DateRangePickerInput_calendarIcon_svg {
    fill: #82888a;
    height: 15px;
    width: 14px;
    vertical-align: middle;
  }
`

export default DatePickerWrapper
